import { DecimalPipe } from '@angular/common';
import { Component, OnInit, Output, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-box-graph',
    templateUrl: './box-graph.component.html',
    styleUrls: ['./box-graph.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BoxGraphComponent implements OnInit {
	@Input() label: string;
	@Input() negative: boolean
	@Input() color: string;
	@Input() width: number = 100;
	@Input() autowidth: boolean = false;
	@Input() value: any;
	@Input() type: string;
	@Input() showDecimals: boolean = false;
	viewbox: string = "0 0 100 60";
	numberWidth = 22;
	validValue: any;

	checkCLass() {
		if (this.color) {
			return this.color
		}
		return ''
	}
	getValue(ev) {
		if (this.type == 'number' || this.type == 'currency') {
			if(!this.showDecimals) {
				var val = Math.floor(parseFloat(this.value));
				if (this.autowidth) {
					this.calculateAutoWidth(val);
				}
				return val;
			}
			else {
				if (this.autowidth) {
					var valMx: string = parseFloat(this.value).toFixed(2);
					console.log(valMx)
					this.calculateAutoWidth(valMx)
					const decimalPipe = new DecimalPipe('en-US');
					const valMxFormatted = decimalPipe.transform(String(valMx), '0.2-2'); 
					return valMxFormatted;
				}
			}
		} else if (this.type == 'minutes') {
			var min = Math.floor(parseFloat(this.value) / 60);
			return min
		}
		return ev
	}

	calculateAutoWidth(value) {
		this.width = value ? value.toString().length * this.numberWidth : 100;
		this.width = this.width >= 100 ? this.width : 100;
	}

	getSegValue(ev) {
		var min = Math.floor(parseFloat(this.value) / 60)
		var sec = parseFloat(this.value) - min * 60

		if (sec < 10) {
			return ':0' + sec
		} else {
			return ':' + sec
		}
	}
	getRoofValue(ev) {
		return Math.floor(parseFloat(this.value) / 1000)
	}
	get1000Value(ev) {
		var a = Math.floor(parseFloat(this.value) - (Math.floor(parseFloat(this.value) / 1000) * 1000));
		return a
		if (a < 10) {
			;
			return '.00' + a.toString() // code...
		} else if (a < 100) {
			return '.0' + a.toString() // code...
		} else if (a < 1000) {
			return '.' + a.toString() // code...
		}
	}

	getInteger(ev: string) {
		const integer = ev.split(' ')[0]
		return integer
	}

	getFraction(ev: string) {
		const fraction = ev.split(' ')[1]
		return fraction
	}
	constructor(
	) {}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.value) {
			this.validValue = this.getValue(this.value);
		}
	}

	ngOnInit() {
	}

}